<mbs-modal [title]="'shared:computers.modals.licenseRequired' | i18next">
  <ng-container modal-body>
    <mbs-alert
      [type]="alertType"
      [icon]="true">
      {{ 'shared:computers.modals.unableToAssignLicense' | i18next }}
    </mbs-alert>
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      [type]="'primary'"
      (click)="baseModal.close()">
      {{ 'shared:buttons.close' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
